export const getChannelCountry = () => {
  const countryMetatag = document.querySelector('meta[name="country"]')
  const defaultValue = 'BR'

  if (!countryMetatag) return defaultValue
  return countryMetatag.content || 'BR'
};
